import { render, staticRenderFns } from "./RoleList.vue?vue&type=template&id=02602c4a&scoped=true"
import script from "./RoleList.vue?vue&type=script&lang=js"
export * from "./RoleList.vue?vue&type=script&lang=js"
import style0 from "./RoleList.vue?vue&type=style&index=0&id=02602c4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02602c4a",
  null
  
)

export default component.exports